import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { URLPolicy } from "@whatslly/types/integrations/URLPolicy";

export const UrlPoliciesSettings = Type.Object({
  policies: Type.Array(URLPolicy),
});
export type UrlPoliciesSettings = TypeBoxToType<typeof UrlPoliciesSettings>;

export const getPoliciesUrlsFromSettings = (urlPoliciesSettings: UrlPoliciesSettings | undefined) =>
  urlPoliciesSettings?.policies?.map((policy) => policy.url) ?? [];

export const convertUrlToUrlPattern = (url: string): string | string[] => {
  try {
    const u = new URL(url);
    const pathname = u.pathname === "/" || u.pathname === "" ? "/**" : u.pathname;
    const wsProtocol = u.protocol === "https:" ? "wss:" : u.protocol === "http:" ? "ws:" : null;

    const make = (protocol: string, host: string) => `${protocol}//${host}${pathname}`;

    const host = u.host;
    const isApex = !host.startsWith("www.") && host.split(".").length === 2;
    const isWww = host.startsWith("www.");
    const apexHost = isWww ? host.slice(4) : host;

    const httpPatterns: string[] = [make(u.protocol, host)];
    if (isApex) httpPatterns.push(make(u.protocol, `www.${host}`));
    if (isApex || isWww) httpPatterns.push(make(u.protocol, `*.${apexHost}`));

    const wsPatterns = wsProtocol ? httpPatterns.map((p) => p.replace(u.protocol, wsProtocol)) : [];

    const all = [...httpPatterns, ...wsPatterns];
    return all.length === 1 ? all[0] : all;
  } catch {
    return "";
  }
};
